export default __webpack_public_path__ + "static/media/dr-rahila.333abb9b.JPG";